<template>
    <GChart
        class="p-0"
        type="ColumnChart"
        :settings="{packages: ['corechart'], language: 'pt-br'}"
        :data="chartDataFinal"
        :options="chartOptions"
    />
</template>

<script>
export default {
    props: ['chartData'],
    data() {
        return {
            chartOptions: {
                fontName: 'Inter',
                fontSize: 14,
                //pieSliceText: 'none' ,
                //pieHole: 0.6,
                height: 170,
                chartArea: {width: '90%', height: '70%'},
                //bar: { groupWidth: '60%' },
                //isStacked: true
            }
        }
    },
    computed: {
        chartDataFinal() {
            return this.chartData
        }
    },
}
</script>

<style scoped>

</style>
